const currencyComma = (val, decimalPlaces = 0) =>{
  if (isNaN(parseFloat(val))) return val;
  if (isNaN(decimalPlaces)) {
    decimalPlaces = 0;
  }
  return '$' + parseFloat(val).toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default currencyComma
